// The starting content for a brand-new conversation: a single start node and
// no edges. A lone start node is terminal, so the flow editor renders its
// add-node menu and the author can branch out from there.
export const initialConversationFlowContent = {
  nodes: [
    {
      id: '1',
      type: 'start',
      position: {
        x: 210,
        y: -30,
      },
      data: {
        label: 'Welcome',
      },
      positionAbsolute: {
        x: 210,
        y: -30,
      },
      dragHandle: '.drag-handle',
      selected: false,
      dragging: false,
    },
  ],
  edges: [],
};
